export const i18nVetPage = {
  components: {
    current_campaign_card: {
      card_title: 'Current campaign',
      start_date: 'Start date',
      duration: 'Duration',
      duration_value: '{{days}} days {{hours}} hours',
      last_update: 'Last update',
      status: 'Status',
      total_biocide: 'Total biocide',
      biocide_unit: '{{totalBiocide}} L',
      electrochlorination_unit: 'Electrochlorination unit',
      coarse_filters: 'Coarse filters',
      fine_filters: 'Fine filters',
      membranes_first_stage: 'Membranes 1st stage',
      membranes_second_stage: 'Membranes 2nd stage',
      flow: 'Flow (m³/h)',
      operating: 'Operating',
      operating_value: '{{operatingValue}}h',
      last_analysis: 'Last analysis',
      chlorine_cw: 'Chlorine CW (mg/L)',
      dp_kpa: 'dP (kPa)',
      clogging: 'Clogging',
      cp_start: 'CP start',
      age: 'Age (days)',
      date_filter: 'Data',
    },
    cip_recommended_card: {
      card_title: 'CIP recommended values',
      reset_values: 'Reset Values',
      hours_ahead: 'Hours ahead',
      dp_will_be: 'dP will be:',
      dp_kpa: '{{kpa}} kPa',
      confidence_interval: 'Confidence interval: {{confidenceInterval}}%',
      predicted_normalized_dp_gain: 'Predicted normalized dP gain:',
      target_dp_gain: 'Target dP gain: {{targetDpGain}}%',
      last_3_cips: 'Last 3 cips average: {{lastThreeCips}}%',
      historical_min: 'Min',
      historical_max: 'Max',
      date_filter_badge: 'Para {{date}}',
    },
  },
  chart: {
    campaign_dp: 'Campaign dP',
    predicted_dp: 'Predicted dP',
    predicted_dp_reduction: 'Predicted dP gain',
    confidence_interval: 'Confidence interval (95%)',
  },
  message: {
    no_data_campaign: {
      title: 'No campaign data',
      message: 'Please select another date',
    },
    no_recommendation_data: {
      title: 'No recommendation data',
      message: 'Please select another date',
    },
    generic_error: {
      title: 'An error occurred',
      message: 'Please try again in few minutes',
    },
  },
};
